import React, { useEffect, useState } from "react";
import { FilterBar, TableData } from "../../components";
import { useDispatch, useSelector } from "react-redux";
import { getCommerceReportService } from "../../services/report/reportService";
import { errorAlert } from "../../helpers/alerts";
import moment from "moment";
import { currencyFormatter } from "../../helpers/util";
import { setTitle } from "redux/slices/uiSlice";
import { getCommercesService } from "services/client/commerceService";
import { setCommerces } from "redux/slices/client/commerceSlice";


const CommerceReportScreen = () => {
  const dispatch = useDispatch();
  const { hoster, bags } = useSelector(store => store.session);
  const { commerces } = useSelector((store) => store.commerces);

  const [list, setList] = useState([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)

  const columns = [
    { name: "datetime", label: "Fecha y hora", sort: ({ createdAt }) => createdAt, format: ({ createdAt }) => moment(createdAt).format('DD/MM/YYYY HH:mm:ss') },
    // { name: "type", label: "Tipo", format: ({ hosterBagId }) => hosterBagId?.type },
    { name: "typeTxn", label: "Movimiento", format: ({ etagSaldo, typeReg }) => ['ABONO', 'COMISION', 'ABONO_COMISION', 'ABONO_DESCUENTO'].includes(typeReg) ? etagSaldo : ['TAE', 'PDS', 'PIN'].includes(typeReg) ? `VENTA (${typeReg})` : '-' },
    { name: "import", label: "Importe", sort: ({ typeReg, amount, operacionSaldo }) => ['TAE', 'PDS', 'PIN'].includes(typeReg) ? parseFloat(amount) : parseFloat(operacionSaldo), format: ({ typeReg, amount, operacionSaldo }) => currencyFormatter.format(['TAE', 'PDS', 'PIN'].includes(typeReg) ? amount : operacionSaldo) },
    { name: "operator", label: "Operadora", format: ({ operator }) => operator },
    { name: "prevBalance", label: "Anterior", format: ({ saldoAnterior }) => saldoAnterior ? currencyFormatter.format(saldoAnterior) : '' },
    { name: "operacionSaldo", label: "Debitado", format: ({ operacionSaldo }) => currencyFormatter.format(operacionSaldo) },
    { name: "currentBalance", label: "Actual", format: ({ saldoActual }) => saldoActual ? currencyFormatter.format(saldoActual) : '' },
  ].filter(Boolean);

  useEffect(() => {
    dispatch(setTitle('Reporte por comercio'));
    if (hoster) return;
    getCommercesService(undefined, true)
      .then((response) => dispatch(setCommerces(response)))
      .catch((e) => errorAlert(e))
  }, []);


  const handlerSubmit = async (data) => {
    if (hoster)
      data.commerce = hoster.id
    if (!(data.commerce && data.type))
      return
    setLoading(true)
    getCommerceReportService({
      ...data,
      page,
      limit
    }).then((result) => {
      setList(result.data)
      setTotal(result.total)
    }).catch((error) => errorAlert(error))
      .finally(() => setLoading(false));
  }

  const [page, setPage] = useState(0)
  const [limit, setLimit] = useState(25)
  const sortedCommerces = [...commerces].sort((a, b) => {
    const order = { 'H2H': 1, 'DISTRIBUIDOR': 2, 'MENUDEO': 3 };
    return order[a.type_commerce] - order[b.type_commerce];
  });

  return (
    <>
      <FilterBar
        handlerFilter={handlerSubmit}
        page={page}
        limit={limit}
        // showButton={true}
        validateButton={(fields) => hoster ? !fields.type : !(fields.commerce && fields.type)}
        defaultValues={{
          date: [new Date(), new Date()],
        }}
        // allValue={null}
        filters={[
          !hoster && {
            name: 'commerce',
            label: "Comercio",
            type: "select",
            data: sortedCommerces?.map((item) => ({ id: item._id, name: item.username })) || [],
            loading: commerces == null
          },
          {
            name: 'type',
            label: "Tipo",
            type: "select",
            data: hoster ? bags.map(item => ({ id: item.type, name: item.type })) : [
              { id: 'TAE', name: "TAE" },
              { id: 'PDS', name: "PDS" },
            ],
          },
          {
            type: "dates",
            name: "date",
            label: "Fecha",
          },
        ]}
      />
      <TableData
        // filters={list}
        loading={loading}
        // sorteable={true}
        // defaultOrderBy={"datetime"}
        onChangePage={setPage}
        onChangeRowsPerPage={setLimit}
        // sorteableData={data => data.map(item => {
        //   columns.map(({ name, format, sort }) => item[`_${name}_`] = sort ? sort(item) : format(item))
        //   return item
        // })}
        total={total}
        dataRows={list}
        dataTitle={columns}
        formatter={(data) => columns.map(({ format }) => format(data))}

      />
    </>
  );
};

export default CommerceReportScreen;
